import { render, staticRenderFns } from "./Addmilestones.vue?vue&type=template&id=c005f146&scoped=true&"
import script from "./Addmilestones.vue?vue&type=script&lang=js&"
export * from "./Addmilestones.vue?vue&type=script&lang=js&"
import style0 from "./Addmilestones.vue?vue&type=style&index=0&id=c005f146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c005f146",
  null
  
)

export default component.exports